const lkrFormatter = new Intl.NumberFormat('en-LK', {
  style: 'currency',
  currency: 'LKR',
  currencyDisplay: 'code',
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat('en-LK', {
  maximumFractionDigits: 2,
});

const numberFormatter3 = new Intl.NumberFormat('en-LK', {
  maximumFractionDigits: 3,
});

export function formatLkr(n: number): string {
  return lkrFormatter.format(n).replace('LKR', 'Rs.');
}

export function formatKwh(n: number): string {
  return `${numberFormatter.format(n)} kWh`;
}

export function formatKwh3(n: number): string {
  return `${numberFormatter3.format(n)} kWh`;
}

export function formatNumber(n: number, decimals = 2): string {
  return new Intl.NumberFormat('en-LK', { maximumFractionDigits: decimals }).format(n);
}
